<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g transform="translate(5.000000, 13.000000)" fill="currentColor" fill-rule="nonzero">
        <path d="M11.1630934,0 L10.2848085,0 L7.00759156,4.1888 L3.74322182,0 L2.83690665,0 C1.269542,0 0,1.5218 0,3.4006 L0,7 L14,7 L14,3.4006 C14,1.5218 12.730458,0 11.1630934,0 Z" id="Path"></path>
    </g>
    <ellipse fill="currentColor" cx="12" cy="8.26666667" rx="4" ry="4.26666667"></ellipse>
</g>
</svg>
